module.exports = __webpack_public_path__ + "static/media/(000077).00fad761.jpg";